"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "id", "onChange", "checked", "label"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/Switch/index.js";
function noop() {}
var defaultProps = {
  onChange: noop,
  id: 'check-default'
};
var Switch = /*#__PURE__*/_react["default"].forwardRef(function Switch(_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    _onChange = _ref.onChange,
    checked = _ref.checked,
    label = _ref.label,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classNames["default"])('form-check form-switch', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    className: "form-check-input",
    type: "checkbox",
    role: "switch",
    ref: ref,
    checked: checked,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    },
    id: id
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 13
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label",
    htmlFor: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 13
    }
  }, label));
});
Switch.defaultProps = defaultProps;
var _default = exports["default"] = Switch;